import { SVGProps } from 'react';

export const MiniMode = (props: SVGProps<SVGSVGElement>) => (
    <svg
        {...props}
        viewBox="0 0 58 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 16.8805C13.6686 16.8805 13.4 17.1491 13.4 17.4805V17.9605C13.4 18.2918 13.6686 18.5605 14 18.5605H23.972C24.3034 18.5605 24.572 18.2918 24.572 17.9605V17.4805C24.572 17.1491 24.3034 16.8805 23.972 16.8805H14ZM11 17.4805C11 15.8236 12.3431 14.4805 14 14.4805H23.972C25.6289 14.4805 26.972 15.8236 26.972 17.4805V17.9605C26.972 19.6173 25.6289 20.9605 23.972 20.9605H14C12.3431 20.9605 11 19.6173 11 17.9605V17.4805Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 28.1607C13.6686 28.1607 13.4 28.4294 13.4 28.7607V29.2407C13.4 29.5721 13.6686 29.8407 14 29.8407H23.972C24.3034 29.8407 24.572 29.5721 24.572 29.2407V28.7607C24.572 28.4294 24.3034 28.1607 23.972 28.1607H14ZM11 28.7607C11 27.1039 12.3431 25.7607 14 25.7607H23.972C25.6289 25.7607 26.972 27.1039 26.972 28.7607V29.2407C26.972 30.8976 25.6289 32.2407 23.972 32.2407H14C12.3431 32.2407 11 30.8976 11 29.2407V28.7607Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 39.44C13.6686 39.44 13.4 39.7087 13.4 40.04V40.52C13.4 40.8514 13.6686 41.12 14 41.12H23.972C24.3034 41.12 24.572 40.8514 24.572 40.52V40.04C24.572 39.7087 24.3034 39.44 23.972 39.44H14ZM11 40.04C11 38.3832 12.3431 37.04 14 37.04H23.972C25.6289 37.04 26.972 38.3832 26.972 40.04V40.52C26.972 42.1769 25.6289 43.52 23.972 43.52H14C12.3431 43.52 11 42.1769 11 40.52V40.04Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34.0278 16.8805C33.6965 16.8805 33.4278 17.1491 33.4278 17.4805V17.9605C33.4278 18.2918 33.6965 18.5605 34.0278 18.5605H43.9998C44.3312 18.5605 44.5998 18.2918 44.5998 17.9605V17.4805C44.5998 17.1491 44.3312 16.8805 43.9998 16.8805H34.0278ZM31.0278 17.4805C31.0278 15.8236 32.371 14.4805 34.0278 14.4805H43.9998C45.6567 14.4805 46.9998 15.8236 46.9998 17.4805V17.9605C46.9998 19.6173 45.6567 20.9605 43.9998 20.9605H34.0278C32.371 20.9605 31.0278 19.6173 31.0278 17.9605V17.4805Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34.0278 28.1607C33.6965 28.1607 33.4278 28.4294 33.4278 28.7607V29.2407C33.4278 29.5721 33.6965 29.8407 34.0278 29.8407H43.9998C44.3312 29.8407 44.5998 29.5721 44.5998 29.2407V28.7607C44.5998 28.4294 44.3312 28.1607 43.9998 28.1607H34.0278ZM31.0278 28.7607C31.0278 27.1039 32.371 25.7607 34.0278 25.7607H43.9998C45.6567 25.7607 46.9998 27.1039 46.9998 28.7607V29.2407C46.9998 30.8976 45.6567 32.2407 43.9998 32.2407H34.0278C32.371 32.2407 31.0278 30.8976 31.0278 29.2407V28.7607Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34.0278 39.44C33.6965 39.44 33.4278 39.7087 33.4278 40.04V40.52C33.4278 40.8514 33.6965 41.12 34.0278 41.12H43.9998C44.3312 41.12 44.5998 40.8514 44.5998 40.52V40.04C44.5998 39.7087 44.3312 39.44 43.9998 39.44H34.0278ZM31.0278 40.04C31.0278 38.3832 32.371 37.04 34.0278 37.04H43.9998C45.6567 37.04 46.9998 38.3832 46.9998 40.04V40.52C46.9998 42.1769 45.6567 43.52 43.9998 43.52H34.0278C32.371 43.52 31.0278 42.1769 31.0278 40.52V40.04Z"
            fill="white"
        />
    </svg>
);
